import { render, staticRenderFns } from "./CustomTagsInput.vue?vue&type=template&id=46201df0&scoped=true&"
import script from "./CustomTagsInput.vue?vue&type=script&lang=js&"
export * from "./CustomTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomTagsInput.vue?vue&type=style&index=0&id=46201df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46201df0",
  null
  
)

export default component.exports